<template>
  <section v-if="!isLoading">
    <div class="flex flex-col space-y-8">
      <input
        required
        v-model="search"
        type="text"
        placeholder="Search employee..."
        class="max-w-lg px-4 py-3 rounded-lg border border-zinc-200 bg-white/70 text-zinc-600 placeholder-gray-500 shadow-sm focus:ring-2 focus:ring-secondaryPalette outline-none"
      />
      <span> Total Employees: {{ itemDetails.length }} </span>
    </div>

    <div class="py-10">
      <ul class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-6">
        <li
          v-for="(item, index) in itemDetails"
          :key="index"
          class="group bg-white rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 flex flex-col items-center justify-center py-6 px-4 hover:-translate-y-2 border border-gray-100"
        >
          <!-- Profile Image -->
          <div class="relative">
            <img
              :src="item.mediaLink"
              alt="profile"
              class="w-24 h-24 sm:w-28 sm:h-28 object-cover rounded-full ring-4 ring-gray-100 group-hover:ring-primaryPalette transition-all duration-300"
            />
          </div>

          <!-- Info -->
          <div class="pt-4 flex flex-col items-center text-center">
            <h2 class="text-base sm:text-lg font-semibold text-primaryPalette">
              {{ item.name }}
            </h2>

            <p class="text-sm text-gray-500 mt-1">
              {{ item.designation }}
            </p>

            <!-- Icons -->
            <div class="flex justify-center items-center gap-4 mt-4">
              <!-- Email -->
              <span
                class="relative flex items-center justify-center w-9 h-9 rounded-full bg-gray-100 text-zinc-600 cursor-pointer hover:bg-primaryPalette hover:text-white transition-all duration-300"
                @click="copyEmail(item.email, index)"
              >
                <MessageSvg class="w-5 h-5" />

                <!-- Tooltip -->
                <transition name="fade">
                  <div
                    v-if="copiedIndex === index"
                    class="absolute -top-10 px-3 py-1 text-xs font-medium bg-black text-white rounded-md shadow-lg whitespace-nowrap"
                  >
                    Copied!
                  </div>
                </transition>
              </span>

              <!-- Mobile -->
              <span
                v-if="item.isPublic"
                class="flex items-center justify-center w-9 h-9 rounded-full bg-gray-100 text-zinc-600 cursor-pointer hover:bg-primaryPalette hover:text-white transition-all duration-300"
              >
                <MobileSvg
                  class="w-6 h-6 cursor-pointertransition"
                  @click="callMobile(item.mobile)"
                />
              </span>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </section>
  <div v-else class="flex justify-center items-center py-4">
    <LoadingGlobal />
  </div>
</template>

<script>
import { ref, onMounted, inject, watch } from 'vue';
import MessageSvg from '@/components/svgs/MessageSvg.vue';
import MobileSvg from '@/components/svgs/MobileSvg.vue';

export default {
  components: { MessageSvg, MobileSvg },
  setup() {
    const axios = inject('$axios');
    const itemDetails = ref([]);
    const filterStatus = ref('employed');
    const isLoading = ref(false);
    const copiedIndex = ref(null);
    const search = ref('');

    const renderEmployeeList = async () => {
      try {
        const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
        const result = await axios.get(
          `https://urchin-app-t57nb.ondigitalocean.app/api/gazette/getEmployees`,
          {
            params: {
              status: filterStatus.value,
              search: search.value
            }
          }
        );

        await delay(2000);
        isLoading.value = false;
        itemDetails.value = result.data || [];
      } catch (error) {
        console.log('renderEmployeeList', error);
        itemDetails.value = [];
      }
    };

    const copyEmail = async (email, index) => {
      try {
        await navigator.clipboard.writeText(email);
        copiedIndex.value = index;

        setTimeout(() => {
          copiedIndex.value = null;
        }, 2000);
      } catch (error) {
        console.error(error);
      }
    };
    const callMobile = (mobile) => {
      if (!mobile) return;

      // Ensure it's a string first
      const cleaned = String(mobile).replace(/[^0-9+]/g, '');
      window.location.href = `tel:${cleaned}`;
    };
    watch(search, () => {
      renderEmployeeList();
    });

    onMounted(async () => {
      isLoading.value = true;
      await renderEmployeeList();
    });

    return {
      itemDetails,
      filterStatus,
      copyEmail,
      isLoading,
      copiedIndex,
      search,
      callMobile
    };
  }
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(6px);
}
</style>
